import React, { Component, createRef } from "react";
import InputText from "../components/InputText.jsx";
import validator from "../components/FieldValidator.jsx";
import "regenerator-runtime/runtime";
import fetcherApi from '../components/FetcherApi.jsx';
import Spinner from '../profile/Information/Spinner.jsx';
import LegalEntityFunctions from "../../components/components/LegalEntityFunctions.jsx";
import Footer from "../../components/components/Footer.jsx";
import NotificationSuccess from "../components/Notifications/NotificationSuccess.jsx";
import ConsentLinks from "../components/Consents/ConsentLinks.jsx";
import TranslationText from "../components/Translation/TranslationText.jsx";
import EmailAndPhoneValidator from "../components/EmailAndPhoneValidator.jsx";
import { withTranslation } from 'react-i18next';
import i18n from "translations/i18n.jsx";
import AutoHideableTitle from "../components/HeaderComponents/AutoHideableTitle.jsx";
import urlTools from "../tools/urlTools.jsx";
import { Link } from "react-router-dom/cjs/react-router-dom.js";
import { DUPLICATE_PHONE, EMAIL_VALIDATION_LIMIT_REACHED, PHONE_VALIDATION_LIMIT_REACHED, VERIFICATION_RESEND_LIMIT_ERROR, WRONG_PASSWORD } from "components/constants/errorCodes.jsx";
import { PasswordInput } from "components/components/PasswordInput.jsx";
import { PhonePrefixSelector } from "components/components/PhonePrefixSelector.jsx";

class BusinessProfileInformation extends Component {
	_isMounted = false;
	constructor(props) {
		super(props);
		this.notificationPopupRef = createRef();
	}

	state = {
		availableCountries: this.props.initialData.availableCountries.map(data => ({ label: data.value, value: data.key })),
		errors: {},
		clientData: null,
		initialClientData: {},
		companyInformation: null,
		companyInformation: null,
		initialCompanyInformation: {},
		submiterror: "",
		dirtyfields: {},
		mandatoryFieldsErrors: {},
		legalEntityId: this.props.initialData.legalEntityId,
		maxPhoneLength: "",
		currentPassword: "",
		showCurrentPasswordField: false,
		vatNumberMaxLength: LegalEntityFunctions.getVatNumberLengths()[this.props.initialData.legalEntityId][LegalEntityFunctions.getVatNumberLengths()[this.props.initialData.legalEntityId].length - 1]
	};

	createSelectCountryItems() {
		const { availableCountries } = this.state;
		let items = [];
		for (let i = 0; i < availableCountries.length; i++) {
			let label = availableCountries[i].label;
			let key = availableCountries[i].value;
			let translationKey = 'country_name_' + label.toLowerCase();
			items.push(<option key={label} value={key}>{i18n.t(translationKey)}</option>);
		}
		return items;
	}

	async componentDidMount() {
		this._isMounted = true;
		const b2bProfileData = (await fetcherApi.get(urlTools.constructRoute("api/B2BProfile/"))).response.data.resultObject;

		if (this._isMounted) {
			let initialMandatoryFieldErrors = {};
			if (!b2bProfileData.clientData.firstName) {
				initialMandatoryFieldErrors['firstName'] = "profile_information_page_mandatory_field_error";
			}

			this.splitVatField(b2bProfileData.companyInformation, b2bProfileData.clientData.legalEntityId);
			initialMandatoryFieldErrors.isVatPayer = validator.validateMandatoryField("isVatPayer", b2bProfileData.companyInformation.isVatPayer, this.props.initialData.validations)
			initialMandatoryFieldErrors.vatSuffix = validator.getVatFieldError(
				b2bProfileData.companyInformation.isVatPayer,
				b2bProfileData.companyInformation.vatSuffix,
				b2bProfileData.clientData.legalEntityId
			);

			this.setState({
				clientData: b2bProfileData.clientData,
				companyInformation: b2bProfileData.companyInformation,
				initialClientData: JSON.parse(JSON.stringify(b2bProfileData.clientData)),
				initialCompanyInformation: JSON.parse(JSON.stringify(b2bProfileData.companyInformation)),
				mandatoryFieldsErrors: initialMandatoryFieldErrors,
				errors: {
					vatSuffix: initialMandatoryFieldErrors.vatSuffix,
					isVatPayer: initialMandatoryFieldErrors.isVatPayer
				},
				dirtyfields: {
					vatSuffix: b2bProfileData.companyInformation.vatRegistrationNumber !== b2bProfileData.companyInformation.vatPrefix + b2bProfileData.companyInformation.vatSuffix
				},
				maxPhoneLength: validator.getPhoneMinLength(this.props.initialData.phonePrefixes, b2bProfileData.clientData.phonePrefix),
			});
		}
	}

	splitVatField(companyInformation, legalEntityId) {
		const vatPrefix = LegalEntityFunctions.getVatNumberPrefixes()[legalEntityId];
		const vatNumber = companyInformation.vatRegistrationNumber;

		companyInformation.vatPrefix = vatPrefix;

		if (!vatNumber?.startsWith(vatPrefix)) {
			companyInformation.vatSuffix = vatNumber ?? "";
			companyInformation.isVatPrefixSavePending = !!vatNumber;
		} else {
			companyInformation.vatSuffix = vatNumber.slice(vatPrefix.length);
			companyInformation.isVatPrefixSavePending = false;
		}
	}

	componentWillUnmount() {
		this._isMounted = false;
		this.setState = (state, callback) => {
			return;
		}
	}

	onChange = e => {
		const { clientData, dirtyfields, initialClientData, mandatoryFieldsErrors, errors } = this.state;

		if (e.prop === 'email') {
			e.value = validator.blockSpaceSymbol(e.value);
		}

		if (initialClientData[e.prop] !== e.value) {
			dirtyfields[e.prop] = true;
		}
		else {
			dirtyfields[e.prop] = false;
		}

		if (e.prop === 'lastName' || e.prop === 'firstName') {
			clientData[e.prop] = validator.blockUnwantedSymbols(e.value);
		}
		else if (e.prop === 'email') {
			clientData[e.prop] = validator.blockSpaceSymbol(e.value);
		}
		else {
			clientData[e.prop] = validator.validate(e.prop, e.value);
		}

		if (e.prop === 'email' && !EmailAndPhoneValidator.IsEmailStructureValid(e.value)) {
			mandatoryFieldsErrors[e.prop] = 'empty_email_error_message';
		}
		else {
			mandatoryFieldsErrors[e.prop] = validator.validateMandatoryField(e.prop, clientData[e.prop], this.props.initialData.validations);
		}

		errors[e.prop] = [];

		this.setState({ clientData, dirtyfields, errors, mandatoryFieldsErrors });
	};

	onChangeCompany = e => {
		const { companyInformation, initialCompanyInformation, dirtyfields, errors, mandatoryFieldsErrors, clientData } = this.state;

		if (e.prop === "vatSuffix") {
			dirtyfields.vatSuffix = initialCompanyInformation.vatRegistrationNumber !== companyInformation.vatPrefix + e.value;
			mandatoryFieldsErrors.vatSuffix = validator.getVatFieldError(companyInformation.isVatPayer, e.value, clientData.legalEntityId);

			companyInformation.isVatPrefixSavePending = false;
		} else {
			dirtyfields[e.prop] = initialCompanyInformation[e.prop] !== e.value
			mandatoryFieldsErrors[e.prop] = validator.validateMandatoryField(e.prop, e.value, this.props.initialData.validations);
		}

		companyInformation[e.prop] = validator.validate(e.prop, e.value);

		errors[e.prop] = [];
		this.setState({ companyInformation, dirtyfields, errors, mandatoryFieldsErrors });
	};

	onIsVatPayerChange = event => {
		const { companyInformation, initialCompanyInformation, errors, clientData, dirtyfields, mandatoryFieldsErrors } = this.state;

		companyInformation.isVatPayer = !!+event.target.value;
		mandatoryFieldsErrors.vatSuffix = validator.getVatFieldError(companyInformation.isVatPayer, companyInformation.vatSuffix, clientData.legalEntityId);
		mandatoryFieldsErrors.isVatPayer = [];
		errors.vatSuffix = [];
		errors.isVatPayer = [];
		dirtyfields.isVatPayer = companyInformation.isVatPayer !== initialCompanyInformation.isVatPayer;

		this.setState({ companyInformation, errors, mandatoryFieldsErrors, dirtyfields });
	}

	onCurrentPasswordChange = e => {
		const { errors } = this.state;
		errors.currentPassword = null;

		this.setState({
			errors,
			currentPassword: e.value
		});
	}

	hasErrors = () => {
		const { errors } = this.state;

		for (var error in errors) {
			if (errors[error] && errors[error].length) {
				return true;
			}
		}

		return false;
	};

	isEmailFieldValid() {
		if (!this.state.dirtyfields.email) {
			return true;
		}

		const emailStructureError = EmailAndPhoneValidator.getEmailStructureError(this.state.clientData.email);
		if (emailStructureError) {
			const { errors } = this.state;
			errors.email = emailStructureError;

			this.setState({ errors });
		}

		return !emailStructureError;
	}

	processErrorResponse(errorCode) {
		const { errors } = this.state;
		switch (errorCode) {
			case VERIFICATION_RESEND_LIMIT_ERROR:
			case EMAIL_VALIDATION_LIMIT_REACHED:
				errors.email = "rate_limit_reached";
				break;
			case PHONE_VALIDATION_LIMIT_REACHED:
				errors.phone = "rate_limit_reached";
				break;
			case DUPLICATE_PHONE:
				errors.phone = "b2b_profile_information_page_duplicate_phone_error";
				break;
			case WRONG_PASSWORD:
				errors.currentPassword = "password_change_page_current_password_incorrect_error";
				break;
			default:
				this.setState({ errorText: errorCode });
				return;
		}

		this.setState({ errors });
	}

	save = async e => {
		this.notificationPopupRef.current.closeClicked();
		const { clientData, companyInformation, errors, dirtyfields, maxPhoneLength, currentPassword } = this.state;
		e.preventDefault();

		const phoneChanged = this.phoneChanged();
		const emailChanged = this.emailChanged();
		const newEmail = clientData.email;

		const isPasswordRequired = phoneChanged || emailChanged

		if (isPasswordRequired && !currentPassword) {
			this.setState({ showCurrentPasswordField: true });
			return;
		} else if (!isPasswordRequired) {
			errors.currentPassword = null;
			this.setState({
				errors,
				showCurrentPasswordField: false,
				currentPassword: ""
			});
		}

		let error = false;

		if (!!clientData.phone) {
			if (this.state.initialClientData.phonePrefix + this.state.initialClientData.phone === clientData.phonePrefix + clientData.phone) {
				dirtyfields['phonePrefixId'] = false;
				dirtyfields['phone'] = false;
			}
			else {
				let phoneError = validator.validatePhonePrefixes(this.props.initialData.phonePrefixes, clientData.phonePrefix, clientData.phone);
				if (phoneError !== "") {
					errors["phone"] = phoneError;
					error = true;
				}
			}
		}

		if (!this.isEmailFieldValid()) {
			error = true;
		}

		if (this.hasErrorsOnSave()) {
			error = true;
		}

		if (!error) {
			if (Object.values(dirtyfields).every(v => v === false)) {
				console.log('no changes detected, skipping update.')
				return;
			}

			clientData.password = currentPassword;
			companyInformation.vatRegistrationNumber = companyInformation.vatSuffix ? companyInformation.vatPrefix + companyInformation.vatSuffix : null;

			const profileUpdate = { ...clientData, ...companyInformation };

			const result = (await fetcherApi.put(urlTools.constructRoute("api/B2BProfile"), JSON.stringify(profileUpdate))).response;
			if (!result.data.success) {
				this.processErrorResponse(result.data.error);
			}
			else {
				const updatedProfile = result.data.resultObject;

				this.splitVatField(updatedProfile.companyInformation, updatedProfile.clientData.legalEntityId);
				this.setState({
					clientData: JSON.parse(JSON.stringify(updatedProfile.clientData)),
					initialClientData: JSON.parse(JSON.stringify(updatedProfile.clientData)),
					companyInformation: updatedProfile.companyInformation,
					initialCompanyInformation: JSON.parse(JSON.stringify(updatedProfile.companyInformation)),
					dirtyfields: {},
					errors: {},
					maxPhoneLength,
					showCurrentPasswordField: false,
					currentPassword: ""
				});

				if (emailChanged) {
					this.notificationPopupRef.current.showEmailPopup(newEmail);
				} else {
					this.notificationPopupRef.current.showPopup()
				}

				this.updateGreetingText(clientData.firstName + " " + clientData.lastName);
			}
		}
		else {
			this.setState({ errors, maxPhoneLength });
		}
	};

	phoneChanged() {
		const { initialClientData, clientData } = this.state;
		return initialClientData.phonePrefix + initialClientData.phone !== clientData.phonePrefix + clientData.phone;
	}

	emailChanged() {
		const { initialClientData, clientData } = this.state;
		return initialClientData.email !== clientData.email;
	}

	updateGreetingText(greetingText) {
		this.props.updateGreetingText(greetingText);
	}

	handleClick = event => {
		this.props.hideNavBar(true);
	}

	onDropDownChange = e => {
		const { clientData, errors, initialClientData, dirtyfields } = this.state;

		const selectedPrefixId = e.prefixId;
		if (initialClientData['phonePrefixId'] !== selectedPrefixId) {
			dirtyfields['phonePrefixId'] = true;
		}
		else {
			dirtyfields['phonePrefixId'] = false;
		}

		clientData.phonePrefixId = selectedPrefixId;
		const prefix = e.prefixValue;
		clientData.phonePrefix = prefix;
		errors['phone'] = [];
		this.setState({
			clientData, errors,
			maxPhoneLength: validator.getPhoneMinLength(this.props.initialData.phonePrefixes, prefix)
		});
	};

	hasErrorsOnSave() {
		let foundErrors = false;
		const { errors, mandatoryFieldsErrors } = this.state;

		for (var fieldError in mandatoryFieldsErrors) {
			if (mandatoryFieldsErrors[fieldError] !== undefined && mandatoryFieldsErrors[fieldError].length > 0) {
				errors[fieldError] = mandatoryFieldsErrors[fieldError]
				foundErrors = true;
			}
		}

		if (!foundErrors) {
			this.setState({ mandatoryFieldsErrors: {} });
		}

		this.setState({ errors });
		return foundErrors;
	};

	onDropDownCountryChange = e => {
		const { companyInformation, initialCompanyInformation, dirtyfields } = this.state;

		if (initialCompanyInformation['countryId'] !== e.value) {
			dirtyfields['countryId'] = true;
		}
		else {
			dirtyfields['countryId'] = false;
		}

		companyInformation.countryId = parseInt(e.target.value);

		this.setState({ companyInformation });
	};

	getCurrentPasswordError = () => {
		if (this.state.errors.currentPassword) {
			return this.state.errors.currentPassword;
		}

		return !this.state.currentPassword ? "profile_information_page_confirm_password_empty_error" : "";
	}

	render() {
		const { clientData, legalEntityId, companyInformation, maxPhoneLength, errors, 
			initialClientData, vatNumberMaxLength } = this.state;

		return (clientData !== null && companyInformation != null) ? (
			<React.Fragment>
				<div className="container page-container profile-page">
					<AutoHideableTitle text={'b2b_profile_information_page_title'} />
					<div className="card card-full-width">
						<div className="card-content">
							<div className="row group-row loyalty-card">
								<div className="column-medium-12 column-desktop-12 column-tablet-12 card-account-info">
									<div className="loyalty-card-image">
										<img src={require("assets/img/rimi-card-front-" + LegalEntityFunctions.getCountryName(legalEntityId) + ".png")} alt="Rimi Card" />
									</div>
									<div className="counter card-number">
										<h3>
											<TranslationText text='b2b_profile_information_page_card_number_title' />
										</h3>
										<div className="card-digits">
											<div className="value">{clientData.card.cardPrefix}</div>
											<div className="value">{clientData.card.cardNumber}</div>
										</div>
									</div>
								</div>
								<div className="column-medium-3 column-desktop-4 column-tablet-12 profile-button-column">
									<Link className="button -secondary full-width" to="/PasswordChange">
										<TranslationText text='password_change_page_link_button' />
									</Link>
								</div>
							</div>
							<hr />
							<h2>
								<TranslationText text='b2b_profile_information_page_account_info_title' />
							</h2>
							<div className="row">

								<div className="column-medium-4 column-desktop-6 column-tablet-12">
									<div className="form-group">
										<div className="form-row">
											<div className={(!!errors['firstName'] && errors['firstName'].length > 0 ? "form-field -has-error" : "form-field") + " -required"}>
												<label htmlFor="first_name" className="form-field__label">
													<TranslationText text='b2b_profile_information_page_fname_field_title' />
												</label>
												{
													initialClientData.firstName
														? <input style={{ color: '#878380', cursor: 'default' }} className="form-field__input" type="text" name="first_name" id="first_name" value={clientData.firstName} readOnly />
														: <InputText
															onChange={this.onChange}
															prop="firstName"
															value={clientData.firstName || ""}
															maxLength="50"
															className="form-field__input"
														/>
												}
											</div>
											<div className="sublabel error-msg show">
												<span>
													<TranslationText text={errors.firstName} />
												</span>
											</div>
										</div>
									</div>
								</div>

								<div className="column-medium-4 column-desktop-6 column-tablet-12">
									<div className="form-group">
										<div className="form-row">
											<div className={(!!errors['lastName'] && errors['lastName'].length > 0 ? "form-field -has-error" : "form-field") + " -required"}>
												<label htmlFor="last_name" className="form-field__label">
													<TranslationText text='b2b_profile_information_page_lname_field_title' />
												</label>
												<InputText
													onChange={this.onChange}
													prop="lastName"
													value={clientData.lastName || ""}
													maxLength="50"
													className="form-field__input"
													type="text"
												/>
											</div>
											<div className="sublabel error-msg show"><span>
												<TranslationText text={errors.lastName} />
											</span></div>
										</div>
									</div>
								</div>

								<div className="column-medium-4 column-desktop-6 column-tablet-12">
									<div className="form-group">
										<div className="form-row">
											<div className={(!!errors['email'] && errors['email'].length > 0 ? "form-field  -has-error" : "form-field") + " -required"}>
												<label htmlFor="email" className="form-field__label">
													<TranslationText text='email_field_label' />
												</label>
												<InputText
													onChange={this.onChange}
													prop="email"
													value={clientData.email}
													maxLength="50"
													className="form-field__input"
												/>
											</div>
											<div className="sublabel error-msg show"><span>
												<TranslationText text={errors.email} />
											</span></div>
										</div>
									</div>
								</div>

							</div>

							<div className="row">

								<div className="column-medium-4 column-desktop-6 column-tablet-12">
									<div className="form-group">
										<div className="form-row">
											<div className="form-field -required">
												<label htmlFor="country_code" className="form-field__label">
													<TranslationText text='b2b_profile_information_page_phone_field_title' />
												</label>
											</div>
										</div>
										<div className={!!errors['phone'] && errors['phone'].length > 0 ? "form-row -phone-number  -has-error" : "form-row -phone-number"}>
											<PhonePrefixSelector
												initialPrefix={clientData.phonePrefixId}
												onChange={this.onDropDownChange}
												phonePrefixes={this.props.initialData.phonePrefixes}
											/>
											<div className="form-field">
												<InputText
													onChange={this.onChange}
													prop="phone"
													value={clientData.phone}
													className="form-field__input -tel"
													type="tel"
													maxLength={maxPhoneLength}
												/>
											</div>
										</div>
										<div className="sublabel error-msg show"><span>
											<TranslationText text={errors.phone} />
										</span></div>
									</div>
								</div>
							</div>

							<hr />

							<h2>
								<TranslationText text='b2b_profile_information_page_comp_info_field_title' />
							</h2>

							<div className="row start">

								<div className="column-medium-4 column-desktop-6 column-tablet-12">
									<div className="form-group">
										<div className="form-row">
											<div className={(!!errors['companyName'] && errors['companyName'].length > 0 ? "form-field  -has-error" : "form-field") + " -required"}>
												<label htmlFor="company-name" className="form-field__label">
													<TranslationText text='b2b_profile_information_page_comp_name_field_title' />
												</label>

												<InputText
													onChange={this.onChangeCompany}
													prop="companyName"
													value={companyInformation.companyName}
													className="form-field__input"
													type="text"
													maxLength="140"
												/>

											</div>
											<div className="sublabel error-msg show">
												<span>
													<TranslationText text={errors.companyName} />
												</span>
											</div>
										</div>
									</div>
								</div>

								<div className="column-medium-4 column-desktop-6 column-tablet-12">
									<div className="form-group">
										<div className="form-row">
											<div className="form-field">
												<label htmlFor="company_registration_number" className="form-field__label">
													<TranslationText text='b2b_profile_information_page_reg_number_field_title' />
												</label>
												<InputText
													value={companyInformation.registrationNumber}
													className="form-field__input"
													disabled={true}
												/>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="row start">
								<div className="column-medium-4 column-desktop-6 column-tablet-12">
									<div className={`form-field -radio -required ${errors.isVatPayer?.length ? "-has-error" : ""}`}>
										<label className="form-field__label">
											<TranslationText text="is_vat_payer_label" />
										</label>
										<div className="form-check inline">
											<input onChange={this.onIsVatPayerChange} className="form-check-input" name="isVatPayer" type="radio" value="1" id="yes"
												checked={companyInformation.isVatPayer === true}
											/>
											<label className="form-check-label" htmlFor="yes">
												<TranslationText text="option_yes" />
												<span></span>
											</label>
										</div>
										<div className="form-check inline">
											<input onChange={this.onIsVatPayerChange} className="form-check-input" name="isVatPayer" type="radio" value="0" id="no"
												checked={companyInformation.isVatPayer === false}
											/>
											<label className="form-check-label" htmlFor="no">
												<TranslationText text="option_no" />
												<span></span>
											</label>
										</div>
										<div className="sublabel error-msg show">
											<span>
												<TranslationText text={errors.isVatPayer} />
											</span>
										</div>
									</div>
								</div>

								<div className="column-medium-4 column-desktop-6 column-tablet-12">
									<div className="form-group">
										<div className="form-row">
											<div className={`form-field ${errors.vatSuffix?.length || companyInformation.isVatPrefixSavePending ? "-has-error" : ""} ${companyInformation.isVatPayer ? "-required" : ""}`}>
												<label htmlFor="vatSuffixInput" className="form-field__label">
													<TranslationText text='b2b_profile_information_page_vat_number_field_title' />
												</label>

												<div className="input-group">
													<InputText
														prop="vatPrefix"
														value={companyInformation.vatPrefix}
														disabled={true}
													/>
													<InputText
														onChange={this.onChangeCompany}
														prop="vatSuffix"
														value={companyInformation.vatSuffix}
														maxLength={vatNumberMaxLength}
													/>
												</div>
											</div>
											<div className="sublabel error-msg show">
												<span>
													{errors.vatSuffix?.length ?
														<TranslationText
															text={errors.vatSuffix}
															options={{ minLength: LegalEntityFunctions.getVatNumberLengths()[legalEntityId][0] }}
														/>
														: null}
													{!errors.vatSuffix?.length && companyInformation.isVatPrefixSavePending ? <TranslationText text="vat_number_verify_prefix_error" /> : null}
												</span>
											</div>
										</div>
									</div>
								</div>

							</div>

							<hr />

							<h2>
								<TranslationText text='b2b_profile_information_page_address_info_title' />
							</h2>

							<div className="row start">

								<div className="column-medium-4 column-desktop-6 column-tablet-12">
									<div className="form-group">
										<div className="form-row">
											<div className="form-field -required">
												<label htmlFor="country" className="form-field__label">
													<TranslationText text='b2b_profile_information_page_country_field_title' />
												</label>
											</div>
											<div className="form-field form-field__select">
												<select value={companyInformation.countryId} onChange={this.onDropDownCountryChange}>
													{this.createSelectCountryItems()}
												</select>
												<svg enableBackground="new 0 0 32 32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="m22.7 12.7-6.7 6.6-6.7-6.6" fill="none" stroke="#a12971" strokeMiterlimit="10" strokeWidth="2" /></svg>                            </div>
										</div>
									</div>
								</div>

								<div className="column-medium-4 column-desktop-6 column-tablet-12">
									<div className="form-group">
										<div className="form-row">
											<div className={(!!errors['legalAddress'] && errors['legalAddress'].length > 0 ? "form-field -has-error" : "form-field") + " -required"}>
												<label htmlFor="company_legal_address" className="form-field__label">
													<TranslationText text='b2b_profile_information_page_address_field_title' />
												</label>
												<InputText
													onChange={this.onChangeCompany}
													prop="legalAddress"
													value={companyInformation.legalAddress}
													className="form-field__input"
													type="text"
													maxLength="60"
												/>
											</div>
											<div className="sublabel error-msg show">
												<span>
													<TranslationText text={errors.legalAddress} />
												</span>
											</div>
										</div>
									</div>
								</div>

								<div className="column-medium-4 column-desktop-6 column-tablet-12">
									<div className="form-group">
										<div className="form-row">
											<div className={(!!errors['city'] && errors['city'].length > 0 ? "form-field -has-error" : "form-field") + " -required"}>
												<label htmlFor="company_city_region" className="form-field__label">
													<TranslationText text='b2b_profile_information_page_city_field_title' />
												</label>

												<InputText
													onChange={this.onChangeCompany}
													prop="city"
													value={companyInformation.city}
													className="form-field__input"
													type="text"
													maxLength="40"
												/>
											</div>
											<div className="sublabel error-msg show">
												<span>
													<TranslationText text={errors.city} />
												</span>
											</div>
										</div>
									</div>
								</div>

								<div className="column-medium-4 column-desktop-6 column-tablet-12">
									<div className="form-group">
										<div className="form-row">
											<div className={!!errors['subTown'] && errors['subTown'].length > 0 ? "form-field  -has-error" : "form-field"}>
												<label htmlFor="company_city_parish" className="form-field__label">
													<TranslationText text='b2b_profile_information_page_subtown_field_title' />
												</label>


												<InputText
													onChange={this.onChangeCompany}
													prop="subTown"
													value={companyInformation.subTown}
													className="form-field__input"
													type="text"
													maxLength="50"
												/>
											</div>
											<div className="sublabel error-msg show">
												<span>
													<TranslationText text={errors.subTown} />
												</span>
											</div>
										</div>
									</div>
								</div>

								<div className="column-medium-4 column-desktop-6 column-tablet-12">
									<div className="form-group">
										<div className="form-row">
											<div className={(!!errors['zipCode'] && errors['zipCode'].length > 0 ? "form-field -has-error" : "form-field") + " -required"}>
												<label htmlFor="company_city_postcode" className="form-field__label">
													<TranslationText text='b2b_profile_information_page_zip_field_title' />
												</label>

												<InputText
													onChange={this.onChangeCompany}
													prop="zipCode"
													value={companyInformation.zipCode}

													className="form-field__input"
													type="text"
													maxLength={legalEntityId === "2" ? "4" : "5"}

												/>


											</div>
											<div className="sublabel error-msg show">
												<span>
													<TranslationText text={errors.zipCode} />
												</span>
											</div>

										</div>
									</div>
								</div>
							</div>
							{
								this.state.showCurrentPasswordField
									? (
										<div className="row group-row">
											<div className="column-desktop-12">
												<h2 style={{ marginBottom: '0px' }}>
													<TranslationText text='profile_information_page_confirm_password_title' />
												</h2>
												<div className="row padded-row">
													<div className="column-desktop-4 column-tablet-6 column-mobile-12">
														<PasswordInput
															label="password_change_page_current_password_label"
															value={this.state.currentPassword}
															onChange={this.onCurrentPasswordChange}
															error={this.getCurrentPasswordError()}
														/>
													</div>
												</div>
											</div>
										</div>
									) : null
							}
							<hr />
							<div className="row profile-footer">
								<div className="column-medium-7 column-desktop-6 column-tablet-12">
									<hr className="spacer" />
									<ConsentLinks preselectedLegalEntityId={this.props.initialData.legalEntityId} business={true} />
								</div>
								<div className="column-medium-3 column-desktop-4 column-tablet-12">
									<div className="form-row">
										<div className="sublabel error-msg show">
											<span>{<TranslationText text={this.state.errorText} />}</span>
										</div>
									</div>
									<button
										type="submit"
										onClick={this.save}
										className="button full-width"
									>
										<TranslationText text='b2b_profile_information_page_save_btn' />
									</button>
									<NotificationSuccess ref={this.notificationPopupRef}></NotificationSuccess>
								</div>
							</div>
						</div>
					</div>
				</div>
				<Footer countrySelectionEnabled={false} legalEntity={this.state.legalEntityId} />
			</React.Fragment>
		) : <Spinner />
	}
}


export default withTranslation()(BusinessProfileInformation);
